function formatCurrency(params: any[]) {
  const currencyCode = params[0] as string;
  const amount = params[1];

  if (!currencyCode || !amount) return "";

  const formattedAmount = new Intl.NumberFormat(navigator.language, {
    style: "currency",
    currency: currencyCode,
  }).format(amount);

  return formattedAmount;
}

export default formatCurrency;
